<template>
  <Teleport to="body">
    <!--  @click.stop="$emit('close')" вместо того чтобы заморачиваться с делегированием логики закрытия,
      я предлагаю на клик по пункту сразу закрывать меню и не мучиться с переменными visible в реестрах
      у нас нет двухуровневых меню, и я не помню ни одного случая, когда нам на платформе после клика по меню
      нужно было держать его открытым -->
    <div
      v-if="visible"
      class="datagrid-context-menu"
      :style="menuStyle"
      @click.stop="$emit('close')"
    >
      <slot :row="row" />
    </div>

    <div
      v-if="visible"
      class="datagrid-context-menu-overlay"
      @click="$emit('close')"
      @contextmenu.prevent="$emit('close')"
    />
  </Teleport>
</template>

<script lang="ts">

type Position = {
  top: number;
  left: number;
};

export default defineComponent({
  name: 'VDataGridContextMenuPopupV2',

  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    position: {
      type: Object as PropType<Position>,
      default: () => ({ top: 0, left: 0 }),
    },
    row: {
      type: Object as PropType<Record<string, unknown>>,
      default: null,
    },
  },

  emits: ['close'],

  data() {
    return {
      adjustedPosition: { ...this.position } as Position,
    };
  },

  computed: {
    menuStyle(): Record<string, string> {
      return {
        top: `${this.adjustedPosition.top}px`,
        left: `${this.adjustedPosition.left}px`,
      };
    },
  },

  watch: {
    visible(val: boolean) {
      if (val) {
        this.adjustedPosition = { ...this.position };
        this.$nextTick(() => this.adjustPosition());
      }
    },
    position: {
      handler(val: Position) {
        this.adjustedPosition = { ...val };
      },
      deep: true,
    },
  },

  methods: {
    adjustPosition(): void {
      const menu = document.querySelector('.datagrid-context-menu') as HTMLElement | null;
      if (!menu) return;

      const rect = menu.getBoundingClientRect();
      const viewport = {
        width: window.innerWidth,
        height: window.innerHeight,
      };

      if (this.adjustedPosition.left + rect.width > viewport.width) {
        this.adjustedPosition.left = viewport.width - rect.width - 10;
      }

      if (this.adjustedPosition.top + rect.height > viewport.height) {
        this.adjustedPosition.top = viewport.height - rect.height - 10;
      }
    },
  },
});
</script>

<style lang="scss">
.datagrid-context-menu {
  position: fixed;
  z-index: 200;

  overflow: hidden;

  min-width: 180px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}

.datagrid-context-menu-overlay {
  position: fixed;
  z-index: 190;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
</style>
